<template>
    <div class="promo-faq-type content-item">
        <div class="FA_Ques_Top">
            <div class="Ques_Top_Banner"><img src="https://resource.rcclchina.com.cn/content/FAQ/FA_Banner2.png"></div>
        </div>
        <div class="FA-shipType">
            <div class="js-shipTypeChange FA-shipType-content">
                <ul class="nav nav-tabs">
                    <li class="" role="presentation" v-for="(shipCategory, i) in shipCategories1" :key="('shipCategory_'+i)"
                        :class="{ active: selectedShipCategory.id == shipCategory.id}" @click="onShipCategoryChange(shipCategory)">
                        <div class="FA-shipType-subTitle">{{shipCategory.subTitle}}</div>
                        <div class="FA-shipType-title">{{shipCategory.title}}</div>
                    </li>

                    <li role="presentation" class="dropdown FA-shipType-more js-moreShip" v-if="shipCategories2.length > 0"
                        :class="{ active: moreShipCategory&&moreShipCategory.id}">
                        <a data-toggle="dropdown">
                            <div style="margin-top:10px;" v-if="!moreShipCategory">
                                更多船队
                                <span class="caret"></span>
                            </div>
                            <div class="dropdown-title" v-else>
                                <div>
                                    <div class="FA-shipType-subTitle">{{moreShipCategory.title}}</div>
                                    <div class="FA-shipType-title">{{moreShipCategory.subTitle}}</div>
                                </div>
                                <span class="caret"></span>
                            </div>
                        </a>
                        <div class="dropdown-menu" style="width:100%;min-width:172px;">
                            <ul>
                                <li role="presentation" v-for="(shipCategory, i) in shipCategories2" :key="('shipCategory2_'+i)"
                        :class="{ active: selectedShipCategory.id == shipCategory.id}" @click="onShipCategoryChange(shipCategory)">
                                    <span class="dropdown-menu-title" style="margin-right:2px;">{{shipCategory.title}}</span>
                                    <span class="dropdown-menu-subTitle">{{shipCategory.subTitle}}</span>
                                </li>

                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="FA_Ques_Search">
            <!--搜索框 START-->
            <div style="" class="search_Ques_Button">
                <div class="">
                    <div class="faq-searchBar textBorder">
                        <div class="input-group">
                            <input type="text" class="form-control textInput1" v-model="searchKeyword">
                            <div class="input-group-btn">
                                <button type="button" class="btn btn-default dropdown-toggle textInput2"
                                    data-toggle="dropdown">
                                    <span class="all_con">{{selectedFaqCategory.subCategory}}</span> <span class="caret"></span>
                                </button>
                                <button id="textInput3" class="btn btn-default textInput3 faq-search-button"
                                    type="button" aria-label="Search" @click="onSearchKeywordChange"></button>

                                <ul id="myTab2" class="nav nav-tabs dropdown-menu pull-right All_list">
                                    <li @click="onFaqCategoryHotNewClick('全部')"><a>全部</a></li>
                                    <li @click="onFaqCategoryHotNewClick('热门')"><a>热门</a></li>
                                    <li v-for="(subCategory, i) in subFaqCategories" :key="('subCategory_'+i)"
                                    @click="onSubFaqCategoryClick(subCategory)"><a>{{subCategory.name}}</a></li>
                                </ul>
                            </div>
                            <!-- /btn-group -->
                        </div>
                        <!-- /input-group -->
                    </div>
                    <!-- /.col-lg-6 -->
                </div>
            </div>
            <!--搜索框 END-->
        </div>

        <div class="selection_sort" ref="SelectCategory">
            <div class="selection_sort-content">
                <div class="sort_tag">
                    <div class="sort_content">选择分类</div>
                    <ul id="myTab" class="nav nav-tabs sort_tag_content">
                        <li @click="onFaqCategoryHotNewClick('热门')" :class="{'bgActive': selectedFaqCategory.category=='热门'}">
                            <span class="hot_img_1"></span>
                            <a id="hot_1"  data-toggle="tab"> 热门 </a>
                            <span class="hot_img"></span>
                        </li>
                        <li v-for="(category, i) in faqCategories" :key="('faqCategory_'+i)"
                        @click="onFaqCategoryClick(category)" data-toggle="tab" class="sele_tab2"
                        :class="{'bgActive': selectedFaqCategory.id==category.id && selectedFaqCategory.subId==0}">
                            <div class="img_icon_wrapper"><img class="img_icon" :src="category.icon" /></div>
                            <a id="safe_1"  data-toggle="tab">{{category.name}}</a>
                            <div v-if="category.subCategories&&category.subCategories.length>0">
                                <ul class="FA-SubCategories js-SubTabChange">
                                    <li v-for="(subCategory, j) in category.subCategories" :key="('subCategory_'+i+'_'+j)"
                                    @click="onSubFaqCategoryClick(subCategory)" :class="{ 'bgActive': selectedFaqCategory.subId == subCategory.id}">
                                        <span>{{subCategory.name}}</span>
                                        <span class="hot_img"></span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li @click="onFaqCategoryHotNewClick('全部')" :class="{'bgActive': selectedFaqCategory.category=='全部'}">
                            <a style="margin-left: 40px;" id="all_1"  data-toggle="tab">显示全部</a>
                            <span class="hot_img"></span>
                        </li>
                    </ul>
                </div>
                <FaqList
                    :faqItems="targetFaqItems"
                    :shipCategory="selectedShipCategory"
                    :faqCategory="selectedFaqCategory"
                />
                <div class="both"></div>
            </div>
        </div>

        <div class="rcclQN__recommend">
            <PromoCruise />
        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import {gioTracking} from "@/utilities/tools";
const FaqList = () => import('@/components/Faq/FaqList')
const PromoCruise = () => import('@/components/Cruise/PromoCruise')
export default {
    name: "Faq",
    components: {
        FaqList,
        PromoCruise
    },
    asyncData ({ store }) {
        const userToken = store.state.user.userReviewToken
        return new Promise((resolve, reject) => {
            return store.dispatch('GET_FAQ', {
                userName: userToken
            })
            .then(()=> {
                resolve();
            })
            .catch((e)=> {
                reject(e)
            })
        })
    },
    data() {
        return {
            selectedShipCategory: {},
            targetFaqItems: [],
            searchKeyword: "",
            lastSearchKeyword: "",
            isShowFaqSubCategories: false,
            selectedFaqCategory: {
                id: 0,
                subId: 0,
                category: "热门",
                subCategory: "热门"
            },
            isShowFaqCategoryLeftArrow: false,
            isShowShipCategorySelect: false,
            isShowFaqCategoryRightArrow: true,
            faqCategoriesWrapperWidth: 0,
            targetFaq: {},
            isShowFaqDetailPopup: false
        }
    },
    beforeMount () {

    },
    methods: {
        searchFaqItems () {

            // 先过滤船队分类
            let faqItems = this.faqItems.filter(r=>r.promoFaqCategories && r.promoFaqCategories.some(c=>c.id == this.selectedShipCategory.id))

            // 过滤关键字
            if (this.searchKeyword && this.searchKeyword.trim().length > 0) {
                const keyword = this.searchKeyword.trim().toUpperCase()
                faqItems = faqItems.filter(r=>r.question && r.answer
                && (r.question.toUpperCase().indexOf(keyword)>= 0 || r.answer.toUpperCase().indexOf(keyword)>= 0 ))

            }

            if (this.selectedFaqCategory.category != "全部") {
                 // 过滤FAQ分类
                if (this.selectedFaqCategory.category == "热门") {
                    faqItems = faqItems.filter(r=>r.isHot)
                } else if (!this.selectedFaqCategory.subCategory || this.selectedFaqCategory.subCategory == ''){
                    faqItems = faqItems.filter(r=>r.category == this.selectedFaqCategory.category)
                } else {
                    faqItems = faqItems.filter(r=>r.category == this.selectedFaqCategory.category
                    && r.subCategory == this.selectedFaqCategory.subCategory)
                }
            }

            if (faqItems.length > 0) {
                // 按照seq排序
                faqItems = _.orderBy(faqItems, ['seq'], ['desc'])

                // 如果搜索的话，按照tag排序
                if (this.searchKeyword && this.searchKeyword.length > 0) {
                    faqItems = this.sortFilterFaq(this.searchKeyword, faqItems)
                }
            }

            this.targetFaqItems = faqItems
        },
        sortFilterFaq (text, faqItems){
            text = text.toUpperCase()
            var topFaqs = []
            var otherFaqs = []
            for (var i = 0; i < faqItems.length; i++) {
                var faq = faqItems[i]
                if (faq.tags && faq.tags.toUpperCase().indexOf(text) >= 0) {
                    topFaqs.push(faq)
                } else {
                    otherFaqs.push(faq)
                }
            }
            topFaqs = _.orderBy(topFaqs, ['seq'], ['desc'])
            otherFaqs = _.orderBy(otherFaqs, ['seq'], ['desc'])

            faqItems = topFaqs.concat(otherFaqs)
            return faqItems
        },
        onShipCategoryChange (shipCategory) {
            this.selectedShipCategory = shipCategory
            this.searchFaqItems()
            this.isShowShipCategorySelect = false
            this.scrollToTop()
        },
        onSearchKeywordChange () {
            if (this.searchKeyword && this.searchKeyword.trim().length > 0) {
                this.searchKeyword = this.searchKeyword.toUpperCase()
                // this.$refs.faqCategoriesWrapper.scroll({
                //     left: this.$refs.faqCategoriesSlideAll.offsetLeft + this.$refs.faqCategoriesSlideAll.offsetWidth
                // , behavior: 'smooth' })
                // this.selectedFaqCategory = {
                //     id: 0,
                //     subId: 0,
                //     category: "全部",
                //     subCategory: ""
                // }
                try {
                    window.gio('page.set', 'FAQ_WD', this.searchKeyword)
                } catch (e) {
                    //console.error(e)
                }
            }
            // 如果输入内容和之前不一样的话，默认跳转到全部类别里面
            if (this.searchKeyword != this.lastSearchKeyword) {
                this.selectedFaqCategory = {
                    id: 0,
                    subId: 0,
                    category: "全部",
                    subCategory: "全部"
                }
            }
            this.lastSearchKeyword = this.searchKeyword
            this.searchFaqItems()
            this.scrollToTop()
        },
        clearSearchKeyword () {
            this.searchKeyword = ''
            this.onSearchKeywordChange()
        },
        onFaqCategoryHotNewClick (value) {
            this.selectedFaqCategory.id = 0
            this.selectedFaqCategory.subId = 0
            this.selectedFaqCategory.category = value
            this.selectedFaqCategory.subCategory = value

            gioTracking('track', 'evt_ButtonClicked',{
              'btnType': `FAQ${value}`
            })
            this.searchFaqItems()
            this.scrollToTop()
        },
        onFaqCategoryClick (faqCategory) {
            gioTracking('track', 'evt_ButtonClicked',{
              'btnType': `FAQ${faqCategory.name}`
            })
            if (faqCategory.subCategories && faqCategory.subCategories.length > 0) {
                return
            }
            this.isShowFaqSubCategories = false
            this.selectedFaqCategory.subId = 0
            this.selectedFaqCategory.subCategory = ''
            this.selectedFaqCategory.id = faqCategory.id
            this.selectedFaqCategory.category = faqCategory.name
            this.searchFaqItems()
            this.scrollToTop()
        },
        onSubFaqCategoryClick (subFaqCategory) {
            this.selectedFaqCategory.subId = subFaqCategory.id
            this.selectedFaqCategory.subCategory = subFaqCategory.name
            const faqCategory = this.faqCategories.find(r=>r.id == subFaqCategory.parentId)
            if (faqCategory && faqCategory.id > 0) {
                this.selectedFaqCategory.id = faqCategory.id
                this.selectedFaqCategory.category = faqCategory.name
            }
            this.isShowFaqSubCategories = false
            this.searchFaqItems()
            this.scrollToTop()
        },
        scrollToTop () {
            const top = this.$refs.SelectCategory.getBoundingClientRect().top + window.scrollY - 200
            window.scroll({
                top: top,
                behavior: 'smooth'
            })
        }
    },
    computed: {
        pageData () {
            return this.$store.state.page.faqData
        },
        faqItems () {
            return this.pageData.itemViewModels ? this.pageData.itemViewModels.filter(r=>r.category) : []
        },
        shipCategories () {
            return this.pageData.categories || []
        },
        shipCategories1 () {
            const count = this.shipCategories.length
            if (count <= 5) {
                return this.shipCategories
            } else {
                return this.shipCategories.slice(0, 5)
            }
        },
        shipCategories2 () {
            const count = this.shipCategories.length
            if (count <= 5) {
                return []
            } else {
                return this.shipCategories.slice(5, count)
            }
        },
        moreShipCategory () {
            return this.shipCategories2.find(r=>r.id == this.selectedShipCategory.id)
        },
        faqCategories () {
            return this.pageData.faqCategories || []
        },
        subFaqCategories () {
            let subFaqCategories = []
            this.faqCategories.forEach(faqCategory => {
                if (faqCategory.subCategories && faqCategory.subCategories.length > 0) {
                    subFaqCategories = subFaqCategories.concat(faqCategory.subCategories)
                }
            })
            return subFaqCategories
        }
    },
    watch: {
        pageData (newValue) {
            const query = this.$router.currentRoute.query
            if (!query || query.source != 'LOCAL_REWARD') return
            if (newValue && newValue.faqCategories && newValue.faqCategories.length > 0) {
                let rewardCategory = newValue.faqCategories.find(r=> r.name == '皇家游享荟')
                if (rewardCategory && rewardCategory.id > 0) {
                    this.selectedFaqCategory.category = rewardCategory.name
                    this.selectedFaqCategory.id = rewardCategory.id
                    this.selectedFaqCategory.subCategory = ""
                }
            }
        },
        shipCategories (newValue) {
            if (newValue && newValue.length > 0) {
                this.selectedShipCategory = newValue[0]
            }
        },
        faqItems () {
            this.searchFaqItems()
        },
        selectedFaqCategory () {
            // console.log('faq category')
        }
    }
}
</script>


<style lang="less" scoped>
@charset "UTF-8";
.promo-faq-type {
  background-color: #f5f5f5;
  min-width: 1300px;

  .rcclQN__recommend {
    width: 90%;
    margin: 0 auto;
    padding-bottom: 20px;
  }
}

/*FA_Ques_Top*/
.FA_Ques_Top .Ques_Top_Banner img{
  width: 100%;
}
.FA_Ques_Top{
  position: relative;
}
.FA_Ques_Search .search_Ques_Button{
  position: relative;
  margin-top: 20px;
}
.FA_Ques_Search .faq-searchBar {
  margin: 0 auto;
    width: 90%;
}

.FA_Ques_Search .textInput1, .FA_Ques_Search .textInput2,
 .FA_Ques_Search .textInput3{
  height: 40px;
}
 .FA_Ques_Search .textInput2{
  width: 135px;
}
 .FA_Ques_Search .textInput2:hover{
  background: #fff;
}
 .FA_Ques_Search .textInput3{
  margin-top: -2px;
}
 .FA_Ques_Search .textInput1{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
 .FA_Ques_Search .textInput3{
  width: 96px;
  background-color: #fbc300;
  color: #fff;
  font-size: 20px;
  right: -1px;
  position: relative;
}
 .FA_Ques_Search .faq-search-button::before{
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  border: 3px solid #fff;
  border-radius: 50%;
  transform: translate(-60%, -60%);
}
 .FA_Ques_Search .faq-search-button::after{
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 11px;
  height: 3px;
  background: #fff;
  border-radius: 2px;
  transform: translate(10%, 85%) rotate(45deg);
}
 .FA_Ques_Search .textBorder{
  padding: 0;
  border: 10px solid #000f57;
}
.both{
  clear: both;
}
.sor{
  background: #000f57;
}
/*搜索框下*/
.selection_sort{
  background: #f5f5f5;
  padding:20px 0;
}
.selection_sort .sort_content{
  width: 100%;
  height: 55px;
  text-align: left;
  line-height: 55px;
  padding-left: 15px;
  color: #333333;
  font-size: 17px;
}
.selection_sort .sort_tag .sort_tag_content .hot_img{
  margin: 0 17px 0 0;
  float: right;
  display: inline-block;
  width: 15px;
  height: 40px;
  background: url(https://resource.rcclchina.com.cn/content/FAQ/right_angle.png) 0 15px no-repeat;
}
.All_list li{
  cursor: pointer;
}

/*左侧tag*/
.selection_sort .sort_tag .sort_tag_content .hot_img_1{
  margin: 0 0 0 20px;
  float: left;
  display: inline-block;
  width: 20px;
  height: 40px;
  background: url(https://resource.rcclchina.com.cn/content/FAQ/hot2img.png) 0 13px no-repeat;
}

.selection_sort .sort_tag .sort_tag_content .img_icon_wrapper {
    margin: 0 0 0 20px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
}
.selection_sort .sort_tag .sort_tag_content .img_icon{

  display: inline-block;
  width: auto;

}

.selection_sort .sort_tag .sort_tag_content li{
  float:none;
//   height: 50px;
  cursor: pointer;
  padding-top:5px;
}
.selection_sort .sort_tag .sort_tag_content li a{
  color: #666666;
  border: none;
  display: inline-block;
  vertical-align: middle;
}
.selection_sort .sort_tag .sort_tag_content li a:hover{
  border: none;
  background: none;
}
.nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover{
  background-color: none;
}
.selection_sort .sort_tag{
  width:22%;
  margin-right:2%;
  background: #fff;
  border-radius: 5px;
  display: inline-block;
}
.selection_sort .sort_tag_detail{
  float: left;
  width: 100%;
}

/*全部*/
.all_pane{
  display: none !important;
  opacity: 0;
}
.all_pane2{
  display: block !important;
  opacity: 1;
}
/*分页*/
.paging{
  width: 87.5%;
  margin: 0 auto 20px;
}
.paging .pagination_pre{
  float: right;
}
.paging .pagination li a{
  padding: 12px 24px;
}
/*全部下拉*/
.dropdown-menu.pull-right{
  right: 90px;
}
.All_list{
  min-width: 135px;
}
.All_list li{
  height: 40px;
  border:1px solid #eaeaea;
  width: 100%;
}
.All_list li a{
  height: 100%;
  line-height: 20px;
}

/*点击li 蓝色背景*/
.sele_sort_bg{
  background: #000f57 !important;
}
.sele_ft{
  color: #fff !important;
}
/*左侧目录 悬停为淡蓝色*/
.sortbgActive{
  background: #ebedf4;
}

/*=========================cruise_list=================================*/

/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* common */

/*------------- 气泡浮窗 -------------*/
.discount__info .tooltip{
    /*display:block !important;*/
    opacity:1 !important;
    left:-60px !important;
}
.discount__info .tooltip.bottom .tooltip-arrow{
    border-bottom-color:#fff !important;
    left: 76% !important;
}
.discount__info .tooltip-inner{
    max-width:260px !important;
    background:#fff !important;
    border-radius:4px;
    box-shadow:0px 1px 15px rgba(0, 0, 0, 0.2);
}
.discount__info .bubbleInfo{
    width:251px;
    text-align:left;
    padding:14px 10px;
}
.bubbleInfo p {
    color:#000;
}

.float--right {
  float: right; }

.checkbox--img {
  display: inline-block; }

.font--purple {
  color: #0C1856; }

.font--orange {
  color: #fbc300; }

.font--grey {
  color: #737373; }

.href--link {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%; }

/*-------------新增样式--------------*/
#filter--list {
    position:relative;
}
.more--discount {
    position:relative;
    z-index:20;
}
.cruise_searchTopImg {
    cursor:pointer;
    width:100%;
    margin-top:20px;
}
.cruise_searchTopImg img {
    width:100%;
}

/**** 一级分类样式 ****/
#myTab {
}
#myTab>li.bgActive{
    background-color:#000f57;
}
#myTab>li.bgActive>a{
    color:#fff;
    background-color:transparent;
}

/**** 船队nav样式 ****/
.FA-shipType .nav-tabs > li > a {
    border: none;
    padding: 0;
}
.FA-shipType .nav-tabs > li > a:hover {
    border: none;
    background-color: transparent;
}
.FA-shipType .nav-tabs > li.active > a,
.FA-shipType .nav-tabs > li.active > a:hover {
    border: none;
}
.FA-shipType .nav .open > a,
.FA-shipType .nav .open > a:focus,
.FA-shipType .nav .open > a:hover {
    background-color: transparent;
}
.FA-shipType {
  position: relative;
  margin-top: -50px;
}
.FA-shipType-content {
    /*overflow: hidden;*/
    width:90%;
    margin:0 auto;
    background-color: #fff;
}
.FA-shipType-content>ul {
    width:100%;
    border:none;
}
.FA-shipType-content>ul>li{
    width:16.66%;
    height:80px;
    text-align:center;
    float:left;
    cursor:pointer;
    padding-top:20px;
    border-right:1px solid #f2f2f2;
    position:relative;
}
.FA-shipType-content>ul>li:last-child{
    border-right:none;
}
.FA-shipType-content>ul>li.active{
    background-color:#010f58;
    color:#fff;
}
.FA-shipType-content>ul>li.active>div,.FA-shipType-more.active .dropdown-title>div>div{
    color:#fff;
}
.FA-shipType-subTitle {
    font-size:13px;
    color: #b4b4b4;
}
.FA-shipType-title {
    font-size:16px;
    color: #b4b4b4;
    font-weight:bold;
}
.FA-shipType-more a {
    font-size: 16px;
    color: #2674b2 !important;
    font-weight: bold;
}
.FA-shipType-moreCon {
    width: 100%;
    margin-top:10px !important;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
    border-radius:4px;
    border:none;
}
.FA-shipType-moreCon:before{
    content:'';
    position:absolute;
    top:-20px;
    left:50%;
    width:0;
    height:0;
    border:10px solid transparent;
    border-bottom-color:#fff;
    transform:translateX(-50%);
    -webkit-transform:translateX(-50%);
    -moz-transform:translateX(-50%);
    -ms-transform:translateX(-50%);
    -o-transform:translateX(-50%);
}
.FA-shipType-more ul {
    width: 100%;
}
.FA-shipType-more ul li{
    width:100%;
    height:40px;
    line-height:40px;
    padding:0 4px;
    text-align:left;
    border-bottom:1px solid #f2f2f2;
}
.FA-shipType-more ul li>span{
    color:#5a5a5a;
}
.FA-shipType-more ul li.active{
    background-color:#1174b8;
}
.FA-shipType-more ul li.active>span{
    color:#fff;
}
.FA-shipType-more > a, .FA-shipType-more > a:focus, .FA-shipType-more > a:hover{
    cursor: pointer !important;
}

.FA-shipType-more .dropdown-title>div{
    display: inline-block;
}
.FA-shipType-more .dropdown-title .caret{
    vertical-align:text-top;
    /*color:#fff;*/
}
.FA-shipType-more >a:focus,
.FA-shipType-more >a:hover,
.FA-shipType-more >a:active {

}
.nav-tabs > li.FA-shipType-more.active > a,
.nav-tabs > li.FA-shipType-more.active > a:focus,
.nav-tabs > li.FA-shipType-more.active > a:hover {
    background-color: transparent !important;
    outline: none;
}
/**** 二级菜单 ****/
.FA-SubCategories {
    /*display: none;*/
}
.FA-SubCategories li{
    line-height:50px;
    padding-left:74px;
    background-color: white;
}
    .FA-SubCategories li.bgActive {
        background-color: rgba(0, 15, 87,.6);
        filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#99000f56,endcolorstr=#99000f56);
        color: #fff;
    }

.selection_sort-content {
    margin:0 auto;
    width:90%;
}

.hold-link {
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
}
.selection_sort .sort_tag .sort_tag_content .FA-SubCategories li {
    padding-top:0;
}
.selection_sort .sort_tag .sort_tag_content .FA-SubCategories li .hot_img {
    background-position-y:20px;
    -ms-background-position-y:20px;
    background-position:0px 20px;
}



/* pc
------------------------------------------------------------------------------------------------------- */
/*-------------pc--------------*/
/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* tablet landscape*/
@media screen and (min-width: 768px) and (max-width: 1200px) {
    .cruise_list_page .filter--select--container {
        position: absolute;
        top: 0px;
        left: 25%;
        margin-top: 20px;

    }

    .cruise_list_page .filter--container--left {
        width: 60%;
        float: left;
    }

    .calendar {
        float: right;
    }
}



/* RESPONSIVE CSS
------------------------------------------------------------------------------------------------- */
/* tablet portrait*/

/*# sourceMappingURL=cruise_list.css.map */

</style>
